// extracted by mini-css-extract-plugin
module.exports = {"container":"categories_container__nYQN_","createRootCategoryButton":"categories_createRootCategoryButton__PpIMc"};